import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import ActionsMenu from '../ActionsMenu';
import BylineBlock from '../BylineBlock';
import ContentBox from '../ContentBox';
import ContentTextRenderer from '../ContentTextRenderer';
import s from './ReadContentBlock.scss';
/**
 * Contains the main content of a comment's read view: comment text, byline, and action menu.
 */
var ReadContentBlock = function (_a) {
    var children = _a.children, className = _a.className, canPostComment = _a.canPostComment, rest = __rest(_a, ["children", "className", "canPostComment"]);
    var _b = useContext(CommentContext), comment = _b.comment, setCanShowActionMenu = _b.setCanShowActionMenu;
    return (React.createElement(ContentBox, __assign({ className: c(s['root'], className), onMouseEnter: function () { return setCanShowActionMenu(true); }, onMouseLeave: function () { return setCanShowActionMenu(false); } }, rest),
        React.createElement(BylineBlock, { className: s['author'] }),
        !!comment.textContent && React.createElement(ContentTextRenderer, { comment: comment }),
        React.createElement(ActionsMenu, { className: s['actions-menu'], canPostComment: canPostComment })));
};
ReadContentBlock.displayName = 'ReadContentBlock';
export default ReadContentBlock;
//# sourceMappingURL=ReadContentBlock.js.map